module.exports = __webpack_public_path__ + "img/receipt.1b76b4a1.svg";